import { render, staticRenderFns } from "./SrollTopButton.vue?vue&type=template&id=06c84f66&scoped=true"
import script from "./SrollTopButton.vue?vue&type=script&lang=js"
export * from "./SrollTopButton.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=06c84f66&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c84f66",
  null
  
)

export default component.exports